var exports = {
  "T": "x0a7806d5--f830ea--label-container",
};

module.exports = exports;
